var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app", dir: "ltr" } }, [
    _c(
      "button",
      {
        on: {
          click: function($event) {
            _vm.cur = Math.floor(Math.random() * _vm.list.length)
          }
        }
      },
      [_vm._v("\n    random change slide\n  ")]
    ),
    _vm._v(" "),
    _c("div", [_vm._v(_vm._s("current slide: " + _vm.cur))]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "slide-container" },
      [
        _c("VueSlideLite", {
          attrs: { list: _vm.list, cur: _vm.cur, dir: "ltr" },
          scopedSlots: _vm._u([
            {
              key: "slide",
              fn: function(ref) {
                var index = ref.index
                return [
                  _c("div", { staticClass: "box" }, [
                    _vm._v(_vm._s("slide " + index))
                  ])
                ]
              }
            }
          ])
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }